import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FilesOutboxEventCountsResult = QueryAtomResult<
  typeof filesOutboxEventCountsQueryAtom
>;

export const filesOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.filesOutboxEventCounts',
  () => ({
    filesOutboxEventCounts: {
      file: true,
    },
  }),
  {
    select: ({ filesOutboxEventCounts }) => filesOutboxEventCounts,
  },
);
